import React, { useState } from 'react';
import { Box, FormControl, FormLabel, Input, Textarea, Button, Text, Heading } from '@chakra-ui/react';
import getCSRFtoken from '../utils/getCSRFtoken';
import fetchWithAuth from '../utils/fetchWithAuth';

const UploadPopulation = ({ onUploadSuccess }) => {
    const csrfToken = getCSRFtoken();
    const [selectedFile, setSelectedFile] = useState(null);
    const [message, setMessage] = useState('');
    const [populationName, setPopulationName] = useState('');
    const [populationDescription, setPopulationDescription] = useState('');
    const [showUploadForm, setShowUploadForm] = useState(false);

    const onFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
    };

    const onUpload = async () => {
        const formData = new FormData();
        formData.append('file', selectedFile);
        formData.append('name', populationName);
        formData.append('description', populationDescription);

        try {
            const response = await fetchWithAuth('/api/upload_population/', {
                method: 'POST',
                headers: {
                    'X-CSRFToken': csrfToken,
                },
                body: formData,
            });

            if (!response.ok) throw new Error('Failed to upload population');

            const data = await response.json();
            setMessage(data.message);
            onUploadSuccess();
            setPopulationName('');
            setPopulationDescription('');
        } catch (error) {
            setMessage('Error uploading the file.');
        }
    };

    const toggleUploadForm = () => {
        setShowUploadForm(!showUploadForm);
    };

    return (
        <Box maxWidth="800px" margin="0 auto">
            <Box
                bg="white"
                p={4}
                borderRadius="md"
                cursor="pointer"
                border="1px solid"
                borderColor="border.default"
                _hover={{ bg: "background.shade2" }}
                onClick={toggleUploadForm}
                justifyContent="center"
            >
                <Heading as="h2" textStyle="h2" textAlign="center">
                    Upload Population
                </Heading>
            </Box>
            {showUploadForm && (
                <Box mt={4}>
                    <FormControl id="name" mb={4}>
                        <FormLabel>Name</FormLabel>
                        <Input type="text" value={populationName} onChange={e => setPopulationName(e.target.value)} />
                    </FormControl>
                    <FormControl id="description" mb={4}>
                        <FormLabel>Description</FormLabel>
                        <Textarea value={populationDescription} onChange={e => setPopulationDescription(e.target.value)} />
                    </FormControl>
                    <FormControl id="file" mb={4}>
                        <FormLabel>Select File</FormLabel>
                        <Input type="file" onChange={onFileChange} />
                    </FormControl>
                    <Button onClick={onUpload} colorScheme="teal" size="lg" width="full" mt={4}>Upload</Button>
                    <Text mt={2}>{message}</Text>
                </Box>
            )}
        </Box>
    );
};

export default UploadPopulation;
